// extracted by mini-css-extract-plugin
export default {"content":"terms-and-conditions_content__BwuTK"};